import React, { useContext, useEffect, useState } from "react";
import { AppointmentContext } from "../context/AppointmentContext";
import { toast, ToastContainer } from "react-toastify";
import config from "../config";
import Footer from "../shared/Footer";
import Header from "../shared/Header";
import { useNavigate } from "react-router-dom";
import HospitalLoader from "../shared/Loader";
import OpdBillPdf from "../shared/OpdBillPdf";
import { pdf } from "@react-pdf/renderer";
import JsBarcode from "jsbarcode";
import { PulseLoader } from "react-spinners";
import FullPageLoader from "../shared/Loader";
import { saveAs } from "file-saver";
import { TiDocumentText } from "react-icons/ti";
import { generateOneTimeToken } from "../utils/authToken";
export default function AppointmentStatusPage() {
  const { hospitalName } = useContext(AppointmentContext);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [bookingAmountInfo, setBookingAmountInfo] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [payNowLoadingId, setPayNowLoadingId] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  const [isPaying, setIsPaying] = useState(false)



  const navigate = useNavigate();

 
  useEffect(() => {
    const fetchAppointments = async () => {
      setLoading(true);
      setFetchError("");

      try {
        const type = hospitalName === "hazra" ? "hazra" : "newtown";
        const contact = sessionStorage.getItem("loginMobile");

        if (!contact) {
          navigate("/login");
          return;
        }
const tokeng = generateOneTimeToken();
        const response = await fetch(
          `${config.API_BASE_URL}/VIEW_FOR_ONLINE_BOOKING_PATIENT`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
            body: JSON.stringify({ TYPE: type, CONTACT: contact, STATUS: "PENDING" }),
          }
        );

        if (!response.ok) throw new Error("Network error");

        const respJson = await response.json();
        const apptList = respJson?.data?.appointment_details;

        if (respJson.status === 200 && Array.isArray(apptList)) {
          const mappedAppointments = apptList.map((item) => {
            const [datePart, ...timeParts] = item.DATE?.split(" ") || [];
            const timePart = timeParts.join(" ").trim();

            return {
              id: item.BOOKING_NO || "",
              date: datePart || "",
              time: timePart || "",
              doctor: item.DOCTOR_NAME || "",
              status: item.STATUS,
              patient: item.PT_NAME || "",
              amount: item.AMOUNT || "",
              contact: item.PT_CONTACT || "",
              department: item.ADMISSION_DEPARTMENT_NAME || "",
              pt_code: item.PT_CODE || "",
              payment_status: item.PAYMENT_STATUS || "",
              online_payment_status: item.ONLINE_PAYMENT_STATUS || ""
            };
          });

          setAppointments(mappedAppointments);
        } else {
          setAppointments([]);
          setFetchError("No appointments found.");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setFetchError("Unable to fetch appointments.");
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, [hospitalName, navigate]);

  const canCancelAppointment = (date, time) => {
  if (!date || !time) return false;

  // Convert "09-02-2026" → parts
  const [day, month, year] = date.split("-");

  // Convert "07:00 PM" → 24-hour
  let [hours, minutes] = time.split(/[: ]/); // ["07","00","PM"]
  const period = time.split(" ")[1]; // AM or PM

  hours = parseInt(hours, 10);

  if (period === "PM" && hours !== 12) hours += 12;
  if (period === "AM" && hours === 12) hours = 0;

  // Create valid JS date
  const appointmentDateTime = new Date(
    year,
    month - 1,
    day,
    hours,
    parseInt(minutes, 10)
  );

  const now = new Date();

  const diffInHours = (appointmentDateTime - now) / (1000 * 60 * 60);

  return diffInHours >= 24;
};
  const handleDelete = async () => {
    if (!selectedAppointmentId) return;

    try {
      // Make the API call
      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/UPDATE_ONLINE_BOOKING_STATUS_TO_HOLD_FOR_REFUND_OR_CANCELLED`, {
        method: 'POST', // or 'PUT' if your API requires it
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': tokeng,
        },
        body: JSON.stringify({
          BOOKINGID: selectedAppointmentId,
          TYPE: sessionStorage.getItem("selectedHospital"),
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update booking status');
      }

      // If API succeeds, update UI state
      setAppointments((prev) => prev.filter((appt) => appt.id !== selectedAppointmentId));
      setSelectedAppointmentId(null);
      setShowModal(false);
      toast.success("Appointment cancelled.");
      setTimeout(() => {
        navigate('/cancel-status');
      }, 3000);
    } catch (error) {
      console.error('Error cancelling appointment:', error);
      toast.error("Failed to cancel appointment. Please try again.");
    }
  };
  // const handleDownloadApplication = async (challanno) => {
  //   try {
  //     setDownloadingId(challanno);

  //     const response = await fetch(
  //       `${config.API_BASE_URL}/PrintPaymentInformation`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({ ORDER_ID: challanno }),
  //       }
  //     );

  //     if (!response.ok) throw new Error("Failed to fetch data");

  //     const data = await response.json();

  //     const blob = await pdf(
  //       <MoneyReceiptPDF data={data.data.print_details[0]} />
  //     ).toBlob();

  //     saveAs(blob, "money_receipt.pdf");
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setDownloadingId(null);
  //   }
  // };

const handleDownloadApplication = async (challanno) => {
  try {
    setDownloadingId(challanno);
const tokeng = generateOneTimeToken();
    const response = await fetch(
      `${config.API_BASE_URL}/PrintPaymentInformation`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
        body: JSON.stringify({ ORDER_ID: challanno }),
      }
    );

    if (!response.ok) throw new Error("Failed to fetch data");

    const data = await response.json();

    // ✅ LAZY IMPORT (THIS FIXES CSP ERROR)
    const { pdf } = await import("@react-pdf/renderer");
    const { default: MoneyReceiptPDF } = await import("./MoneyReceiptPDF");

    const blob = await pdf(
      <MoneyReceiptPDF data={data.data.print_details[0]} />
    ).toBlob();

    saveAs(blob, "money_receipt.pdf");
  } catch (err) {
    console.error("PDF download error:", err);
  } finally {
    setDownloadingId(null);
  }
};

  const toggleDropdown = (appointmentId) => {
    setOpenDropdownId(openDropdownId === appointmentId ? null : appointmentId);
  };

  const closeAllDropdowns = () => {
    setOpenDropdownId(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdowns = document.querySelectorAll('[data-dropdown]');
      let insideDropdown = false;
      dropdowns.forEach((dropdown) => {
        if (dropdown.contains(event.target)) insideDropdown = true;
      });
      if (!insideDropdown) closeAllDropdowns();
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const fetchOpdBillByPtCode = async (pt_code) => {
    try {
      const effectivePtCode = pt_code || "CNCI2251108-N15";
const tokeng = generateOneTimeToken();
      const res = await fetch(`${config.API_BASE_URL}/FetchslipDataOfOPD`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
        body: JSON.stringify({ pT_CODE: effectivePtCode, type: "newtown" }),
      });

      if (!res.ok) {
        toast.error("Failed to fetch OPD bill data.");
        return null;
      }

      const result = await res.json();

      if (result.status === 200 && result.data) {
        return result.data;
      } else {
        toast.error("Bill data not available.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching OPD bill:", error);
      toast.error("Something went wrong while fetching bill data.");
      return null;
    }
  };

  const generateBarcodeBase64 = (text) => {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, text, {
      format: "CODE128",
      displayValue: true,
      fontSize: 12,
      width: 2,
      height: 40,
      margin: 0,
    });
    return canvas.toDataURL("image/png");
  };

  const handlePrintOpdBill = async (pt_code) => {

    closeAllDropdowns();

    try {
      const billData = await fetchOpdBillByPtCode(pt_code);
      if (!billData) return;

      const billNo = billData?.Group2?.[0]?.BILL_NO;
      if (!billNo || typeof billNo !== "string" || billNo.trim() === "") {
        toast.error("Invalid or missing bill number for barcode.");
        return;
      }

      let barcodeImage = null;
      try {
        barcodeImage = generateBarcodeBase64(billNo);
      } catch (error) {
        console.error("Barcode generation error:", error);
        toast.error("Failed to generate barcode.");
        return;
      }

      try {
        const blob = await pdf(<OpdBillPdf data={billData} barcodeImage={barcodeImage} />).toBlob();
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
      } catch (error) {
        console.error("Error generating PDF:", error);
        toast.error("Failed to generate PDF.");
      }
    } catch (error) {
      console.error("Unexpected error in handlePrintOpdBill:", error);
      toast.error("Something went wrong.");
    }
  };


  const openPayNowModal = async (order) => {
    setPayNowLoadingId(order.id);
    try {
      const tokeng = generateOneTimeToken();
      const response = await fetch(`${config.API_BASE_URL}/PROC_GET_BOOKING_AMOUNT_ID`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": tokeng,
        },
        body: JSON.stringify({
          BOOKINGID: order.id,
          TYPE: hospitalName === "hazra" ? "hazra" : "newtown",
        }),
      });

      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();

      if (data?.status !== 200 || !data?.data) {
        toast.error("Invalid booking info");
        return;
      }

      setBookingAmountInfo(data.data);
      setSelectedOrder(order);
    } catch (error) {
      console.error("Error fetching booking amount:", error);
      toast.error("Unable to fetch booking amount");
    } finally {
      setPayNowLoadingId(null); // Stop loading
    }
  };



  const closePayNowModal = () => {
    setSelectedOrder(null);
    setBookingAmountInfo(null);
  };

  const handleProceedToPayment = async () => {
    if (!bookingAmountInfo) {
      toast.error("Booking information is missing.");
      return;
    }
    try {
      setIsPaying(true)
      const orderId = bookingAmountInfo.ORDER_ID;
      const customerId = bookingAmountInfo.BOOKING_NO;
      const totalAmount = Number(bookingAmountInfo.REGISTRATION_AMT);

      // 🔹 Dynamic MultiAccount split (example: 30% + 70%)
      const part1 = Math.round(totalAmount * 0.3);
      const part2 = totalAmount - part1;

      const multiAccountInstructionDtls =
        `${part1}|INR|GRPT||${part2}|INR|NEFT`;
      const tokeng = generateOneTimeToken();
      const response = await fetch(
        //  `${config.API_BASE_URL}/CreatePayment`,
        "https://www.sampark.cnci.ac.in/api/CreatePayment",
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-API-Key": tokeng },
          body: JSON.stringify({
            amount: totalAmount,
            orderNo: orderId,
            customerId: customerId,
            MultiAccountInstructionDtls: multiAccountInstructionDtls
          })
        }
      );

      const data = await response.json();
      setTimeout(() => {
        submitToSbiEpay(data);
      }, 80);
    } catch (err) {
      console.error(err);
      setIsPaying(false);
      toast.error("Unable to initiate payment");
    }

  };

  const submitToSbiEpay = ({
    encryptTrans,
    encryptMulti,
    merchIdVal,
    actionUrl
  }) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = actionUrl;

    const t = document.createElement("input");
    t.type = "hidden";
    t.name = "EncryptTrans";
    t.value = encryptTrans;

    const m = document.createElement("input");
    m.type = "hidden";
    m.name = "MultiAccountInstructionDtls";
    m.value = encryptMulti;

    const merch = document.createElement("input");
    merch.type = "hidden";
    merch.name = "merchIdVal";
    merch.value = merchIdVal;

    form.appendChild(t);
    form.appendChild(m);
    form.appendChild(merch);

    document.body.appendChild(form);
    form.submit();
  };

  // const getStatusColor = (status) => {
  //   const colors = {
  //     PENDING: "bg-red-500 text-white",
  //     CONFIRM: "bg-green-500 text-white",
  //     HOLD_FOR_REFUND: "bg-red-100 text-red-800 border-red-200",
  //   };
  //   return colors[status] || "bg-gray-100 text-gray-800 border-gray-200";
  // };

  return (
    <>

      <Header />
      {loading ? (
        <FullPageLoader />
      ) : (
        <main className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            className="mt-16"
          />

          <div className="container mx-auto px-4 py-2">
            {/* Header Section */}
            <div className="text-center">

              <h3 className="text-4xl md:text-4xl font-bold text-gray-800">
                <i className="fas fa-calendar-check text-blue-500"></i>&nbsp;
                Pending Appointments
              </h3>


              <p className="text-gray-600 text-lg">
                Viewing appointments at{" "}
                <span className="font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  {hospitalName === "hazra"
                    ? "CNCI, Hazra in Kolkata"
                    : "CNCI, New Town in Kolkata"}
                </span>
              </p>
            </div>

            {/* Main Content */}
            <div>
              {appointments.length > 0 ? (
                <>
                  {/* Desktop Table View */}
                  <div className="hidden lg:block">
                    <table className="w-full">
                      <thead className=" text-white text-center" style={{ backgroundColor: "#467FCF" }}>
                        <tr>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Sl No.</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Booking ID</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Patient</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Doctor</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Department</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Date & Time</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Appoitment Status</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Amount</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Payment Status</th>
                          <th className="px-4 py-4 text-left text-sm font-semibold uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100">
                        {appointments.map((appt, index) => (
                          <tr key={index} className="hover:bg-blue-50 transition-colors duration-200 whitespace-nowrap text-center">
                            <td className="px-2 py-3 text-xs font-medium text-gray-900 text-center">{index + 1}</td>
                            <td className="px-3 py-3">
                              <span className="font-mono text-s bg-gray-100 px-2 py-1 rounded whitespace-nowrap">{appt.id}</span>
                            </td>
                            <td className="px-3 py-3 text-xs text-gray-900 max-w-[120px] truncate" title={appt.patient}>{appt.patient}</td>
                            <td className="px-3 py-3 text-xs text-gray-900 max-w-[130px] truncate" title={`Dr. ${appt.doctor}`}>Dr. {appt.doctor}</td>
                            <td className="px-3 py-3 text-xs text-gray-600 max-w-[100px] truncate" title={appt.department}>{appt.department}</td>
                            <td className="px-3 py-3 text-xs text-gray-900">
                              <div className="whitespace-nowrap">
                                <div className="font-medium">{appt.date}</div>
                                <div className="text-gray-600">{appt.time}</div>
                              </div>
                            </td>

                            <td className="px-3 py-3">
                              <span className={`inline-flex items-center px-2 py-2 rounded-full text-xs font-medium border whitespace-nowrap bg-red-500 text-white`}>
                                {appt.status}
                              </span>
                            </td>
                            <td className="px-3 py-3 text-sm font-bold text-green-600 whitespace-nowrap">₹{appt.amount}</td>

                            <td className="px-3 py-3">
                              {appt.payment_status === "NO" ? (
                                <button
                                  onClick={() => openPayNowModal(appt)}
                                  disabled={payNowLoadingId === appt.id}
                                  className={`inline-flex items-center gap-1 px-3 py-2 text-white text-xs font-semibold rounded-lg shadow-md transform transition-all duration-200
        ${payNowLoadingId === appt.id ? "bg-gray-400 cursor-not-allowed" : "bg-red-600 hover:scale-105 animate-blink"}`}
                                >
                                  {payNowLoadingId === appt.id ? (
                                    <>
                                      <svg
                                        className="animate-spin h-4 w-4 text-white"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <circle
                                          className="opacity-25"
                                          cx="12"
                                          cy="12"
                                          r="10"
                                          stroke="currentColor"
                                          strokeWidth="4"
                                        ></circle>
                                        <path
                                          className="opacity-75"
                                          fill="currentColor"
                                          d="M4 12a8 8 0 018-8v8H4z"
                                        ></path>
                                      </svg>
                                      <span className="ml-2">Loading...</span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="relative flex h-2 w-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                                      </span>
                                      Pay Now
                                    </>
                                  )}
                                </button>
                              ) : (
                                <span className="inline-block px-3 py-1 text-xs font-semibold text-green-700 bg-green-100 rounded-full">
                                  Payment Successful
                                </span>
                              )}
                            </td>



                            <td className="px-3 py-3">
                              <div className="relative inline-block text-left" data-dropdown>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      toggleDropdown(appt.id)
                                    }}
                                    className="flex items-center gap-2 px-3 py-1.5 text-sm text-white bg-gray-700 hover:bg-gray-800 rounded-md shadow transition duration-150"
                                  >
                                    Action
                                    <i
                                      className={`fa-solid fa-chevron-down transform transition-transform duration-200 ${openDropdownId === appt.id ? "rotate-180" : ""}`}
                                    />
                                  </button>


                             <div
                                    className={`${openDropdownId === appt.id ? "block" : "hidden"}
          absolute right-0 z-50 mt-2 w-56 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5 border border-gray-100
          ${index >= appointments.length - 2 ? "dropdown-up" : ""}`}
                                    data-dropdown
                                  >
                                  <div className="py-2">
                                    {/* {appt.status === "CONFIRM" && (
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handlePrintOpdBill(appt.pt_code);
                                          closeAllDropdowns();
                                        }}
                                        className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                      >
                                        <i className="fa-solid fa-print text-blue-600 mr-3 w-4"></i>
                                        Print OPD Bill
                                      </button>
                                    )} */}
                                    {appt.online_payment_status === "S" && (
                                      <button
                                        onClick={() => handleDownloadApplication(appt.id)}
                                        disabled={downloadingId === appt.id}
                                        className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50"
                                      >
                                        {downloadingId === appt.id ? (
                                          <>
                                            <svg className="animate-spin h-4 w-4 mr-2" />
                                            Downloading...
                                          </>
                                        ) : (
                                          <>
                                            <TiDocumentText />
                                            &nbsp;Print Receipt
                                          </>
                                        )}
                                      </button>

                                    )}
                                     {canCancelAppointment(appt.date, appt.time) && (
                                    <button
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedAppointmentId(appt.id);
                                        setShowModal(true);
                                        closeAllDropdowns();
                                      }}
                                      className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
                                    >
                                      <i className="fa-solid fa-trash text-red-600 mr-3 w-4"></i>
                                      Cancel Appointment
                                    </button>
                                      )}
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="lg:hidden divide-y ">
                    {appointments.map((appt, index) => (
                      <div key={index} className="p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 border border-gray-100 mb-2">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-1 rounded">
                                #{index + 1}
                              </span>
                              <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border bg-red-400 text-white`}>
                                {appt.status}
                              </span>
                            </div>
                            <h3 className="text-lg font-semibold text-gray-900 mb-1">{appt.patient}</h3>
                            <p className="text-sm text-gray-600">Dr. {appt.doctor}</p>
                          </div>
                          <div className="text-right">
                            <div className="text-2xl font-bold text-green-600 mb-1">₹{appt.amount}</div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Booking ID</div>
                            <div className="font-mono bg-gray-100 px-2 py-1 rounded text-xs">{appt.id}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Department</div>
                            <div className="text-gray-900">{appt.department}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Date</div>
                            <div className="text-gray-900 font-medium">{appt.date}</div>
                          </div>
                          <div>
                            <div className="text-gray-500 text-xs uppercase tracking-wide mb-1">Time</div>
                            <div className="text-gray-900 font-medium">{appt.time}</div>
                          </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-3">
                          {appt.payment_status === "NO" ? (
                            <button
                              onClick={() => openPayNowModal(appt)}
                              className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 bg-red-500 hover:from-red-600 hover:to-pink-600 text-white text-sm font-semibold rounded-lg shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200"
                            >
                              <span className="relative flex h-2 w-2">
                                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
                              </span>
                              Pay Now
                            </button>
                          ) : (
                            <span className="inline-block px-3 py-1 text-xs font-semibold text-green-700 bg-green-100 rounded-full">
                              Payment Successful
                            </span>
                          )}


                          <div className="relative" data-dropdown>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleDropdown(appt.id);
                              }}
                              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium text-white bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 rounded-lg shadow-md hover:shadow-lg transition-all duration-200"
                            >
                              {/* <i className="fa-solid fa-ellipsis-v" /> */}
                              Action
                              <i
                                className={`fa-solid fa-chevron-down transform transition-transform duration-200 ${openDropdownId === appt.id ? 'rotate-180' : ''
                                  }`}
                              />
                            </button>

                            <div
                              className={`${openDropdownId === appt.id ? "block" : "hidden"} 
            absolute right-0 z-50 mt-2 w-56 bg-white rounded-xl shadow-2xl ring-1 ring-black ring-opacity-5 border border-gray-100
            ${index >= appointments.length - 2 ? "dropdown-up" : ""}`}
                              data-dropdown
                            >
                              <div className="py-2">
                                {appt.online_payment_status === "S" && (
                                  <button
                                    onClick={() => handleDownloadApplication(appt.id)}
                                    disabled={downloadingId === appt.id}
                                    className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50"
                                  >
                                    {downloadingId === appt.id ? (
                                      <>
                                        <svg className="animate-spin h-4 w-4 mr-2" />
                                        Downloading...
                                      </>
                                    ) : (
                                      <>
                                        <TiDocumentText />
                                        &nbsp;Print Receipt
                                      </>
                                    )}
                                  </button>

                                )}

                                {/* {appt.status === "CONFIRM" && (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlePrintOpdBill(appt.pt_code);
                                      closeAllDropdowns();
                                    }}
                                    className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                                  >
                                    <i className="fa-solid fa-print text-blue-600 mr-3 w-4"></i>
                                    Print OPD Bill
                                  </button>
                                )} */}
                                 {canCancelAppointment(appt.date, appt.time) && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedAppointmentId(appt.id);
                                    setShowModal(true);
                                    closeAllDropdowns();
                                  }}
                                  className="flex items-center w-full px-4 py-3 text-sm text-gray-700 hover:bg-red-50 hover:text-red-700 transition-colors duration-200"
                                >
                                  <i className="fa-solid fa-trash text-red-600 mr-3 w-4"></i>
                                  Cancel Appointment
                                </button>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="text-center py-20">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gray-100 rounded-full mb-6">
                    <i className="fas fa-calendar-times text-gray-400 text-3xl"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-700 mb-2">No Appointments Found</h3>
                  <p className="text-gray-500">{fetchError || "You don't have any appointments yet."}</p>
                </div>
              )}
            </div>
          </div>

          {/* Cancel Modal */}
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 backdrop-blur-sm p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 relative overflow-hidden">
                <button
                  onClick={() => setShowModal(false)}
                  className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl transition-colors duration-200 z-10"
                  aria-label="Close cancel modal"
                >
                  <i className="fa-solid fa-times"></i>
                </button>

                <div className="bg-red-500 px-6 py-4">
                  <div className="flex items-center text-white">
                    <div className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 rounded-full mr-3">
                      <i className="fa fa-trash text-red-600 hover:text-red-800 cursor-pointer transition duration-150" aria-hidden="true"></i>

                    </div>
                    <h2 className="text-xl font-bold text-white">Cancel Appointment</h2>
                  </div>
                </div>

                <div className="p-6">
                  <div className="mb-6">
                    <div className="bg-gray-50 rounded-lg p-4 mb-4">
                      <div className="text-sm text-gray-600 mb-1">Booking ID</div>
                      <div className="font-mono font-bold text-gray-800 text-lg">{selectedAppointmentId}</div>
                    </div>
                    <p className="text-gray-600">Are you sure you want to cancel this appointment?</p>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <button
                      onClick={handleDelete}
                      className="flex-1 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-105"
                    >
                      Yes, Cancel Appointment
                    </button>
                    <button
                      onClick={() => setShowModal(false)}
                      className="flex-1 px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-800 rounded-lg font-semibold transition-all duration-200"
                    >
                      Keep Appointment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Payment Modal */}
          {selectedOrder && bookingAmountInfo && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
                {/* Modal Header */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-white">
                      <div className="flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 rounded-full mr-3">
                        <i className="fas fa-credit-card text-black text-lg"></i>
                      </div>
                      <h2 className="text-xl font-bold text-white">Complete Payment</h2>
                    </div>
                    <button
                      onClick={closePayNowModal}
                      className="text-blue-200 hover:text-white transition-colors duration-200"
                      aria-label="Close payment modal"
                    >
                      <i className="fas fa-times text-lg"></i>
                    </button>
                  </div>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 rounded-xl p-5 mb-6 border border-gray-100">
                    <div className="space-y-4">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Booking No:</span>
                        <span className="font-bold text-gray-800 text-xs ">{bookingAmountInfo.BOOKING_NO}</span>
                      </div>
                      {/* <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Mode:</span>
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${bookingAmountInfo.DEVELOPMENT_MODE === "YES"
                          ? "bg-yellow-100 text-yellow-800 border border-yellow-200"
                          : "bg-green-100 text-green-800 border border-green-200"
                          }`}>
                          {bookingAmountInfo.DEVELOPMENT_MODE === "DEVELOPMENT_MODE" ? "Development" : "Production"}
                        </span>
                      </div> */}
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600 font-medium">Order ID:</span>
                        <span className="font-mono text-sm bg-white px-2 py-1 rounded border">{bookingAmountInfo.ORDER_ID}</span>
                      </div>
                      <div className="border-t pt-4 mt-4">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-700 font-semibold text-lg">Amount:</span>
                          <div className="text-right">
                            <div className="text-3xl font-bold text-green-600">₹{bookingAmountInfo.REGISTRATION_AMT}</div>
                            {/* <div className="text-sm text-gray-500">Including all charges</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <button
                    onClick={handleProceedToPayment}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 mb-4"
                  >
                    <i className="fas fa-shield-alt mr-2"></i>
                    Pay ₹ {Number(bookingAmountInfo.REGISTRATION_AMT).toFixed(2)}
                  </button> */}

                  <button
                    onClick={handleProceedToPayment}
                    disabled={isPaying}
                    className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 mb-4
    ${isPaying
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700"}
  `}
                  >
                    {isPaying ? (
                      <span className="flex items-center justify-center">
                        <span className="animate-spin h-4 w-4 mr-2 border-2 border-white border-t-transparent rounded-full" />
                        Processing...
                      </span>
                    ) : (
                      <>
                        <i className="fas fa-shield-alt mr-2"></i>
                        Pay ₹{Number(bookingAmountInfo.REGISTRATION_AMT).toFixed(2)} Securely
                      </>
                    )}
                  </button>


                  {/* <p className="text-xs text-gray-500 text-center leading-relaxed">
                    Your payment information is encrypted and secure. We accept all major credit cards, debit cards, and UPI payments.
                  </p> */}
                </div>
              </div>
            </div>
          )}

        </main>
      )}
      <Footer />
    </>
  );
}